<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>

        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="row">
            <div class="col-md-12">
              <vs-breadcrumb
                align="left"
                :items="
                  [
                  {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Admin/adminDashboard'
                    },
                    {
                      title: 'Question Bank Archives',
                      url: '/#/dashboard/Admin/questionbankarchives',
                      active: true
                    }
                  ]"
              ></vs-breadcrumb>
              <div class="heading mt-3">
                <h3 class="text-secondary">Question Bank Archives</h3>
              </div>
            </div>
            <!-- <ul class="nav">
                <router-link to="/dashboard/Admin/questionbankarchives/PostAssessment">Post Assessment</router-link>
                <router-link to="/dashboard/Admin/questionbankarchives/PreAssessment">Pre Assessment</router-link>
              </ul>
            <router-view></router-view>-->
            <QuestionbankArchives />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionbankArchives from "../../commonPages/QuestionBankArchives";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

export default {
  data: () => ({
    isSidebar: false
  }),
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar,
    QuestionbankArchives
  }
};
</script>

<style>
.nav-link.disabled {
  font-weight: bold !important;
  font-size: 15px !important;
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}
</style>

<style scoped>
#menu-toggle {
  display: none;
}

.card-body {
  padding: 0px !important;
}

.tab-item {
  background: white;
  border: 1px #d5dadf solid;
  border-left: 1px solid #d5dadf;
  box-shadow: 0 2px 3px rgba(213, 218, 223, 0.35);
  padding: 15px;
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 15px;
}

.tab-item:hover,
.tab-item.active {
  box-shadow: 0px 3px 3px 2px rgba(213, 218, 223, 0.35);
  border-left: 1px solid #009ad2;
}

.tab-item__heading {
  font-weight: bold;
  font-size: 18px;
  line-height: 1.3em;
  letter-spacing: 0.02em;
  color: #6c757d;
  margin: 0px;
}

.tab-item__subheading {
  font-size: 15px;
  color: #6c757d;
  margin: 0px;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}

.correct {
  color: green;
  font-weight: bold;
}
</style>
